import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

interface InteractionHeaderProps {
  mandatoryCount: number;
  optionalCount: number;
  pendingCount: number;
  hasForms: boolean;
  canBypass: boolean;
  submitting: boolean;
  onSkip: () => void;
  onSubmit: () => void;
}

export const InteractionHeader: React.FC<InteractionHeaderProps> = ({
  mandatoryCount,
  optionalCount,
  pendingCount,
  hasForms,
  canBypass,
  submitting,
  onSkip,
  onSubmit,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      px: 2,
      py: 1.25,
      bgcolor: mandatoryCount > 0 ? 'warning.light' : 'v4.tableEven',
      borderBottom: '1px solid',
      borderColor: 'v4.border',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
        Interactions
      </Typography>
      {mandatoryCount > 0 && (
        <Chip
          label={`${mandatoryCount} Mandatory`}
          size="small"
          sx={{ height: 20, fontSize: '10px', fontWeight: 600, bgcolor: 'warning.main', color: 'common.white' }}
        />
      )}
      {optionalCount > 0 && (
        <Chip
          label={`${optionalCount} Optional`}
          size="small"
          sx={{ height: 20, fontSize: '10px', fontWeight: 600, bgcolor: 'v4.tableEven', color: 'text.secondary' }}
        />
      )}
      {pendingCount > 0 && (
        <Chip
          label={`${pendingCount} Pending`}
          size="small"
          sx={{ height: 20, fontSize: '10px', fontWeight: 600, bgcolor: 'info.light', color: 'info.dark' }}
        />
      )}
    </Box>
    <Box sx={{ display: 'flex', gap: 1 }}>
      {canBypass && mandatoryCount > 0 && (
        <Button size="small" onClick={onSkip} sx={{ fontSize: '11px', textTransform: 'none', color: 'text.secondary' }}>
          Skip (Bypass)
        </Button>
      )}
      {!canBypass && mandatoryCount === 0 && hasForms && (
        <Button size="small" onClick={onSkip} sx={{ fontSize: '11px', textTransform: 'none', color: 'text.secondary' }}>
          Skip
        </Button>
      )}
      <Button
        size="small"
        variant="contained"
        onClick={onSubmit}
        disabled={submitting}
        sx={{ fontSize: '11px', textTransform: 'none', bgcolor: 'v4.accent', '&:hover': { bgcolor: 'v4.accent', opacity: 0.9 } }}
      >
        {submitting ? <CircularProgress size={14} sx={{ color: 'common.white' }} /> : 'Submit Interactions'}
      </Button>
    </Box>
  </Box>
);
